import React, { useEffect, useRef, useState } from "react";
import * as Shared from "../components/CivicShared";
const { api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN, Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound, AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3, Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer, TileLayer, useMapEvents } = Shared;

function EmployerJobPage({ onBack, onJobs }) {
  const [form, setForm] = useState({
    title: "",
    org: "",
    description: "",
    location: "",
    apply_link: "",
    employer_name: "",
    employer_phone: "",
    employer_email: "",
    category: "",
    employment_type: "Full-time",
    salary: "",
    experience: "",
    qualification: "",
    openings: "1",
    deadline: "",
    contact_preference: "Phone",
    website: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const change = (key, value) => {
    setForm((old) => ({ ...old, [key]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSuccess("");
    setError("");

    try {
      const r = await api.post("/jobs", form);

      setSuccess(
        r.data?.message ||
        "Job submitted successfully for review."
      );

      setForm({
        title: "",
        org: "",
        description: "",
        location: "",
        apply_link: "",
        employer_name: "",
        employer_phone: "",
        employer_email: "",
        category: "",
        employment_type: "Full-time",
        salary: "",
        experience: "",
        qualification: "",
        openings: "1",
        deadline: "",
        contact_preference: "Phone",
        website: "",
      });
    } catch (err) {
      setError(
        err.response?.data?.detail ||
        "Unable to submit the job. Please check the information and try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <SimplePage title="Post a Job" onBack={onBack}>
      <div className="employer-page-intro">
        <span className="jobs-kicker">EMPLOYER JOB POSTING</span>
        <h2>Connect with candidates in your local community.</h2>
        <p>
          Submit your vacancy with complete employer contact information.
          After review and approval, candidates will be able to contact
          you directly.
        </p>
      </div>

      {success && (
        <div className="job-success">
          <CheckCircle2 size={20} />
          <div>
            <strong>Job submitted successfully</strong>
            <p>{success}</p>
          </div>
        </div>
      )}

      {error && (
        <div className="job-error">
          {error}
        </div>
      )}

      <form className="employer-form" onSubmit={submit}>
        <div className="employer-form-section">
          <h3>Job Information</h3>

          <div className="employer-form-grid">
            <label>
              Job Title *
              <input
                value={form.title}
                onChange={(e) => change("title", e.target.value)}
                placeholder="e.g. Sales Executive"
                required
              />
            </label>

            <label>
              Company / Organisation *
              <input
                value={form.org}
                onChange={(e) => change("org", e.target.value)}
                placeholder="Company name"
                required
              />
            </label>

            <label>
              Job Category
              <input
                value={form.category}
                onChange={(e) => change("category", e.target.value)}
                placeholder="Sales, IT, Retail, Hospitality..."
              />
            </label>

            <label>
              Employment Type
              <select
                value={form.employment_type}
                onChange={(e) => change("employment_type", e.target.value)}
              >
                <option>Full-time</option>
                <option>Part-time</option>
                <option>Contract</option>
                <option>Internship</option>
                <option>Temporary</option>
              </select>
            </label>

            <label>
              Work Location *
              <input
                value={form.location}
                onChange={(e) => change("location", e.target.value)}
                placeholder="Vijayanagar, Bengaluru"
                required
              />
            </label>

            <label>
              Salary / Salary Range
              <input
                value={form.salary}
                onChange={(e) => change("salary", e.target.value)}
                placeholder="e.g. ₹18,000 – ₹25,000/month"
              />
            </label>

            <label>
              Experience
              <input
                value={form.experience}
                onChange={(e) => change("experience", e.target.value)}
                placeholder="e.g. 0–2 years"
              />
            </label>

            <label>
              Qualification
              <input
                value={form.qualification}
                onChange={(e) => change("qualification", e.target.value)}
                placeholder="e.g. 12th / Graduate"
              />
            </label>

            <label>
              Number of Openings
              <input
                value={form.openings}
                onChange={(e) => change("openings", e.target.value)}
                placeholder="1"
              />
            </label>

            <label>
              Application Deadline
              <input
                value={form.deadline}
                onChange={(e) => change("deadline", e.target.value)}
                placeholder="e.g. 15 October 2026"
              />
            </label>
          </div>
        </div>

        <div className="employer-form-section">
          <h3>Job Description</h3>

          <label>
            Describe the role, responsibilities and requirements *
            <textarea
              rows="8"
              value={form.description}
              onChange={(e) => change("description", e.target.value)}
              placeholder="Describe the job, responsibilities, required skills and other relevant information..."
              required
            />
          </label>
        </div>

        <div className="employer-form-section">
          <h3>Employer Contact</h3>

          <div className="employer-form-grid">
            <label>
              Recruiter / Contact Person *
              <input
                value={form.employer_name}
                onChange={(e) => change("employer_name", e.target.value)}
                placeholder="Contact person name"
                required
              />
            </label>

            <label>
              Phone Number *
              <input
                value={form.employer_phone}
                onChange={(e) => change("employer_phone", e.target.value)}
                placeholder="Employer contact number"
                required
              />
            </label>

            <label>
              Email Address
              <input
                type="email"
                value={form.employer_email}
                onChange={(e) => change("employer_email", e.target.value)}
                placeholder="recruiter@company.com"
              />
            </label>

            <label>
              Preferred Contact
              <select
                value={form.contact_preference}
                onChange={(e) => change("contact_preference", e.target.value)}
              >
                <option>Phone</option>
                <option>WhatsApp</option>
                <option>Email</option>
                <option>Website</option>
              </select>
            </label>

            <label>
              Company Website
              <input
                value={form.website}
                onChange={(e) => change("website", e.target.value)}
                placeholder="https://example.com"
              />
            </label>

            <label>
              Apply Online URL
              <input
                value={form.apply_link}
                onChange={(e) => change("apply_link", e.target.value)}
                placeholder="https://example.com/careers"
              />
            </label>
          </div>
        </div>

        <div className="jobs-posting-notice">
          <strong>Before submitting</strong>
          <p>
            Please provide accurate employment information. Job listings
            are reviewed before they are published. Candidates should
            independently verify the employer and job opportunity.
          </p>
        </div>

        <div className="employer-form-actions">
          <button
            type="button"
            className="civic-btn secondary"
            onClick={onJobs}
          >
            View Jobs
          </button>

          <button
            type="submit"
            className="civic-btn primary"
            disabled={submitting}
          >
            {submitting ? "Submitting..." : "Submit Job for Review"}
          </button>
        </div>
      </form>
    </SimplePage>
  );
}





function PostJobPage(props) { return <EmployerJobPage {...props} />; }
export default PostJobPage;
